import { MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

interface WhatsAppButtonProps {
  className?: string;
  size?: "default" | "sm" | "lg" | "xl" | "icon";
  children?: React.ReactNode;
}

export const WhatsAppButton = ({ className, size = "default", children }: WhatsAppButtonProps) => {
  const handleClick = () => {
    window.open("https://wa.me/27616850671", "_blank");
  };

  return (
    <Button
      variant="whatsapp"
      size={size}
      onClick={handleClick}
      className={className}
    >
      <MessageCircle className="h-5 w-5" />
      {children || "Contact Us on WhatsApp"}
    </Button>
  );
};
